/**
 * Hariom ERP - Quality Control store (persisted, starts empty).
 * QC lab staff enter each test report.
 */
import { createCrudStore } from './createCrudStore'

export interface QCTest {
  id: string
  batch: string
  product: string
  testType: string
  standard: string
  result: string   // passed | failed | conditional | pending
  measured: number
  reqMin: number
  reqMax: number
  unit: string
  date: string
  by: string
}

export const useQCStore = createCrudStore<QCTest>('hariom-erp-qc')
